// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownloadOutlinedSvg from "@fishx/icons-svg/es/asn/DownloadOutlined";
import FishxIcon from '../components/FishxIcon';

var DownloadOutlined = function DownloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownloadOutlinedSvg
  }));
};

DownloadOutlined.displayName = 'DownloadOutlined';
export default React.forwardRef(DownloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownloadOutlined.js
// module id = 2470
// module chunks = 0